<template>
    <div class="accordion accordion-flush my-4" id="accordionActivities">
        <div class="accordion-item mb-3 border-radius-20 border-bottom-0 bg-white">
            <h6 class="accordion-header mb-2" id="activity-headingOne" @click="resetActivity">
                <span class="bg-white btn-link" type="button" data-bs-toggle="collapse"
                      data-bs-target="#activity-collapseOne" aria-expanded="true"
                      aria-controls="activity-collapseOne">
                      {{ trans('general.module.report.update_popup.step.details.select_today_activity') }}
                </span>
            </h6>
            <div id="activity-collapseOne" class="accordion-collapse collapse show"
                 aria-labelledby="activity-headingOne" data-bs-parent="#accordionActivities">
                <div class="col-md-6 mb-3">
                    <k-select
                        v-model="classActivity"
                        :options="activities"
                        :required="true"
                        :show-selected-options="false"
                        auto-close="true"
                        :server-side-search="true"
                        :placeholder="trans('general.module.report.update_popup.step.details.today_activities')"
                        :label="'Select Activity'"
                        v-on:search="loadClassActivities"/>
                </div>
            </div>
        </div>
        <div class="accordion-item mb-3 border-radius-20 border-bottom-0 bg-white">
            <h6 class="accordion-header mb-2" id="activity-headingTwo" @click="resetActivity">
                <span class="collapsed bg-white btn-link" type="button" data-bs-toggle="collapse"
                      data-bs-target="#activity-collapseTwo" aria-expanded="false"
                      aria-controls="activity-collapseTwo">
                     {{ trans('general.module.report.update_popup.step.details.select_another_activity') }}
                </span>
            </h6>
            <div id="activity-collapseTwo" class="accordion-collapse collapse"
                 aria-labelledby="activity-headingTwo" data-bs-parent="#accordionActivities">
                <div class="col-md-6 mb-3">
                    <SettingSelect
                        v-model="activity" type="activity"
                        :label="trans('general.module.report.update_popup.step.details.fields.select_activity')">
                    </SettingSelect>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SettingSelect from "../../../../theme/atoms/SettingSelect.vue";
import moment from "moment/moment";
import GeneralReportForm from "../GeneralReportForm.vue";
import KSelect from "../../../../theme/molecules/KSelect.vue";

export default {
    name: "Activity",
    extends: GeneralReportForm,
    components: {KSelect, SettingSelect},
    data() {
        return {
            model: {
                ...this.value,
                activity_id: null,
                activity: null,
                time: null,
            },

            activities: [],
            activity: null,
            classActivity: null,
        };
    },
    watch: {
        model: {
            handler: function (value) {
                this.internalUpdate = true;
                this.$emit('input', value);
            },
            deep: true
        },
        activity: function (val) {
            if (val) this.setDataFromSettings();
        },
        classActivity: function (val) {
            if (val) {
                this.setDataFromActivityPlan(val[0]);
            }
        }
    },
    methods: {
        loadClassActivities(search) {
            const params = {
                search: search,
                search_fields: 'name:like',
                limit: 10
            };
            axios.get(`/child-report/class/${this.classId}/today-activities`, {params})
                .then((response) => {
                    const data = response.data.data ?? [];
                    this.activities = data.map((val) => {
                        return {
                            id: val.id,
                            label: val.title,
                            data: val
                        };
                    });
                });
        },
        setDataFromSettings() {
            this.model.time = moment().format('YYYY-MM-DD HH:mm:ss');
            this.model.activity_id = this.activity[0].id;
            this.model.activity = this.activity[0].label;
            this.model.description = this.activity[0]?.description ?? this.activity[0]?.data?.value ?? this.activity[0]?.value ?? '';
        },
        setDataFromActivityPlan(activity) {
            this.model.time = activity.data.start;
            this.model.activity_id = activity.data.options[0].id;
            this.model.activity = activity.label;
            this.model.description = activity.data.description ?? activity.data.options[0].description;
        },
        resetActivity() {
            this.activity = null;
            this.model.activity_id = null;
            this.model.activity = null;
            this.model.time = null;
            this.model.description = '';
        }
    },
    mounted() {
        this.loadClassActivities('');
    }
};
</script>
